export var NetworkInterfaceType;
(function (NetworkInterfaceType) {
    NetworkInterfaceType[NetworkInterfaceType["Unknown"] = 1] = "Unknown";
    NetworkInterfaceType[NetworkInterfaceType["Ethernet"] = 6] = "Ethernet";
    NetworkInterfaceType[NetworkInterfaceType["TokenRing"] = 9] = "TokenRing";
    NetworkInterfaceType[NetworkInterfaceType["Fddi"] = 15] = "Fddi";
    NetworkInterfaceType[NetworkInterfaceType["BasicIsdn"] = 20] = "BasicIsdn";
    NetworkInterfaceType[NetworkInterfaceType["PrimaryIsdn"] = 21] = "PrimaryIsdn";
    NetworkInterfaceType[NetworkInterfaceType["Ppp"] = 23] = "Ppp";
    NetworkInterfaceType[NetworkInterfaceType["Loopback"] = 24] = "Loopback";
    NetworkInterfaceType[NetworkInterfaceType["Ethernet3Megabit"] = 26] = "Ethernet3Megabit";
    NetworkInterfaceType[NetworkInterfaceType["Slip"] = 28] = "Slip";
    NetworkInterfaceType[NetworkInterfaceType["Atm"] = 37] = "Atm";
    NetworkInterfaceType[NetworkInterfaceType["GenericModem"] = 48] = "GenericModem";
    NetworkInterfaceType[NetworkInterfaceType["FastEthernetT"] = 62] = "FastEthernetT";
    NetworkInterfaceType[NetworkInterfaceType["Isdn"] = 63] = "Isdn";
    NetworkInterfaceType[NetworkInterfaceType["FastEthernetFx"] = 69] = "FastEthernetFx";
    NetworkInterfaceType[NetworkInterfaceType["Wireless80211"] = 71] = "Wireless80211";
    NetworkInterfaceType[NetworkInterfaceType["AsymmetricDsl"] = 94] = "AsymmetricDsl";
    NetworkInterfaceType[NetworkInterfaceType["RateAdaptDsl"] = 95] = "RateAdaptDsl";
    NetworkInterfaceType[NetworkInterfaceType["SymmetricDsl"] = 96] = "SymmetricDsl";
    NetworkInterfaceType[NetworkInterfaceType["VeryHighSpeedDsl"] = 97] = "VeryHighSpeedDsl";
    NetworkInterfaceType[NetworkInterfaceType["IPOverAtm"] = 114] = "IPOverAtm";
    NetworkInterfaceType[NetworkInterfaceType["GigabitEthernet"] = 117] = "GigabitEthernet";
    NetworkInterfaceType[NetworkInterfaceType["Tunnel"] = 131] = "Tunnel";
    NetworkInterfaceType[NetworkInterfaceType["MultiRateSymmetricDsl"] = 143] = "MultiRateSymmetricDsl";
    NetworkInterfaceType[NetworkInterfaceType["HighPerformanceSerialBus"] = 144] = "HighPerformanceSerialBus";
    NetworkInterfaceType[NetworkInterfaceType["Wman"] = 237] = "Wman";
    NetworkInterfaceType[NetworkInterfaceType["Wwanpp"] = 243] = "Wwanpp";
    NetworkInterfaceType[NetworkInterfaceType["Wwanpp2"] = 244] = "Wwanpp2";
})(NetworkInterfaceType || (NetworkInterfaceType = {}));
export var OperationalStatus;
(function (OperationalStatus) {
    OperationalStatus[OperationalStatus["Up"] = 1] = "Up";
    OperationalStatus[OperationalStatus["Down"] = 2] = "Down";
    OperationalStatus[OperationalStatus["Testing"] = 3] = "Testing";
    OperationalStatus[OperationalStatus["Unknown"] = 4] = "Unknown";
    OperationalStatus[OperationalStatus["Dormant"] = 5] = "Dormant";
    OperationalStatus[OperationalStatus["NotPresent"] = 6] = "NotPresent";
    OperationalStatus[OperationalStatus["LowerLayerDown"] = 7] = "LowerLayerDown";
})(OperationalStatus || (OperationalStatus = {}));
//# sourceMappingURL=INetworkService.js.map